<template>
  <div class="">
    <div data-v-d871d47a="" data-v-4f04d936="" class="Findings">
      <div data-v-d871d47a="" class="head_area">
        <div data-v-d871d47a="" class="leftImg"></div>
        <span data-v-d871d47a="" class="head_text">动态</span><span data-v-d871d47a="" class="right_menu"></span>
      </div>
      <div data-v-d871d47a="" class="FindingsContent">
        
        
        <div data-v-d871d47a="" class="mentItem"  @click="$parent.goNav('/message')">
          <div data-v-d871d47a="" class="leftArea">
            <img
              data-v-d871d47a=""
              src="data:image/png;base64,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"
              alt=""
              class="menuIcon"
            /><span data-v-d871d47a="" class="mentText">官方动态</span
            ><!---->
          </div>
        </div>
        <div data-v-d871d47a="" class="mentItem" @click="showNoActivity">
          <div data-v-d871d47a="" class="leftArea">
            <img
              data-v-d871d47a=""
              src="data:image/png;base64,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"
              alt=""
              class="menuIcon"
            /><span data-v-d871d47a="" class="mentText">大舞台</span
            ><!---->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {};
  },
  created() {},
  methods: {
    showNoActivity() {
      this.$parent.showTost(0, '暂无活动');
    },
  },
};
</script>
    
<style scoped lang="scss">
.Findings[data-v-d871d47a] {
    width: 100%;
    height: 92vh;
    overflow: hidden;
    background-color: #f3f4fa
}

.Findings .head_area[data-v-d871d47a] {
    height: 1.2rem;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    box-sizing: border-box;
    background-color: #f3f4fa;
    z-index: 999
}

.Findings .head_area .leftImg[data-v-d871d47a] {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    width: 2.45333rem;
    height: .88rem;
    text-align: left;
    z-index: 999
}

.Findings .head_area .leftImg .top_logo[data-v-d871d47a] {
    margin-left: .26667rem;
    height: .88rem
}

.Findings .head_area .head_text[data-v-d871d47a] {
    font-size: .48rem;
    font-family: PingFang SC;
    font-weight: 500;
    color: #1d2548;
    width: 30%;
    text-align: center
}

.Findings .head_area .right_menu[data-v-d871d47a] {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    text-align: right;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: end;
    -webkit-justify-content: flex-end;
    -ms-flex-pack: end;
    justify-content: flex-end;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center
}

.Findings .head_area .right_menu .right_menu_down[data-v-d871d47a] {
    width: .53333rem;
    height: .53333rem
}

.Findings .head_area .right_menu .right_menu_notice[data-v-d871d47a] {
    width: auto;
    height: .53333rem;
    position: relative;
    margin-right: .8rem;
    margin-left: .4rem
}

.Findings .head_area .right_menu .right_menu_notice .right_menu_setting[data-v-d871d47a] {
    position: absolute;
    width: .64rem;
    height: .64rem;
    left: 0
}

.Findings .FindingsContent[data-v-d871d47a] {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column
}

.Findings .FindingsContent .mentItem[data-v-d871d47a],.Findings .FindingsContent[data-v-d871d47a] {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center
}

.Findings .FindingsContent .mentItem[data-v-d871d47a] {
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    width: 9.17333rem;
    height: 1.6rem;
    background: #fff;
    border-radius: .26667rem;
    margin-bottom: .26667rem
}

.Findings .FindingsContent .mentItem .leftArea[data-v-d871d47a] {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center
}

.Findings .FindingsContent .mentItem .leftArea .menuIcon[data-v-d871d47a] {
    width: .64rem;
    height: .64rem;
    margin-left: .32rem
}

.Findings .FindingsContent .mentItem .leftArea .mentText[data-v-d871d47a] {
    font-size: .42667rem;
    font-family: PingFang SC;
    font-weight: 500;
    color: #1d2548;
    margin-left: .32rem
}

.Findings .FindingsContent .mentItem .leftArea .total[data-v-d871d47a] {
    min-width: .48rem;
    min-height: .48rem;
    background: #ff3170;
    border: .02667rem solid #fff;
    border-radius: 50%;
    padding-left: .10667rem;
    padding-right: .10667rem;
    padding-top: .02667rem;
    padding-bottom: .02667rem;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    font-size: .26667rem;
    font-family: PingFang SC;
    font-weight: 500;
    color: #fff;
    margin-left: .10667rem
}

.Findings .FindingsContent .mentItem .leftArea .total[data-v-d871d47a] {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center
}
</style>



// WEBPACK FOOTER //
// src/components/mode/discover.vue